export default __webpack_public_path__ + "static/media/image-elo.a42b006a.svg";